"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var React = __importStar(require("react"));

var recharts_1 = require("recharts");

var RadialChart = function RadialChart(_a) {
  var dataSet = _a.dataSet,
      lowerRadius = _a.lowerRadius,
      barWidth = _a.barWidth,
      radiusStep = _a.radiusStep;
  return React.createElement("div", {
    className: "stats-radial-chart"
  }, React.createElement(recharts_1.PieChart, {
    width: 244,
    height: 244
  }, lowerRadius && barWidth && radiusStep && dataSet.map(function (data, idx) {
    return React.createElement(recharts_1.Pie, {
      startAngle: -45,
      endAngle: 315,
      key: "data-" + idx,
      data: data,
      dataKey: "value",
      cx: 122,
      cy: 122,
      innerRadius: lowerRadius + idx * radiusStep,
      outerRadius: lowerRadius + idx * radiusStep + barWidth,
      fill: "#8884d8"
    }, data.map(function (entry, index) {
      return React.createElement(recharts_1.Cell, {
        key: "cell-" + index,
        fill: entry.color,
        strokeWidth: 3
      });
    }));
  })));
};

exports.RadialChart = RadialChart;
RadialChart.defaultProps = {
  lowerRadius: 60,
  barWidth: 15,
  radiusStep: 15
};